/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateExecuteResponse {
    getFixupPrototypeFunction() { return TemplateExecuteResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateExecuteResponse>): TemplateExecuteResponse {
        let obj = Object.assign(new TemplateExecuteResponse(), model);
        TemplateExecuteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateExecuteResponse>): TemplateExecuteResponse {
        if (!model) return null;
        return TemplateExecuteResponse.newInstance(<TemplateExecuteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateExecuteResponse) {
        if (!obj) return;

        models.TemplateExecuteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateExecuteResponse): boolean {
        Object.setPrototypeOf(obj, TemplateExecuteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Job identifier of the executed template
     */
    data: any;

}
